'use client';

import dynamic from 'next/dynamic';
import styles from './DitherBody.module.css';

/**
 * Holds the `ssr: false` call so NightsSeen can stay a Server Component —
 * App Router forbids `ssr: false` outside a Client Component.
 *
 * The fallback is the empty frame the canvas draws into, which is what the
 * section shows anyway until the body PNG has decoded. It renders on the
 * server, so the grid cell keeps its height and nothing shifts on hydration.
 */
const DitherBody = dynamic(() => import('./DitherBody'), {
  ssr: false,
  loading: () => <div className={styles.frame} aria-hidden="true" />,
});

export default DitherBody;
